/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_gloves_barrette = /** @type {(inputs: {}) => string} */ () => {
	return `Bary`
};

const da_attributes_gloves_barrette = /** @type {(inputs: {}) => string} */ () => {
	return `Stribe`
};

const de_attributes_gloves_barrette = /** @type {(inputs: {}) => string} */ () => {
	return `Barette`
};

const en_attributes_gloves_barrette = /** @type {(inputs: {}) => string} */ () => {
	return `Barette`
};

const es_attributes_gloves_barrette = /** @type {(inputs: {}) => string} */ () => {
	return `Barrettes`
};

const fr_attributes_gloves_barrette = /** @type {(inputs: {}) => string} */ () => {
	return `Barrettes`
};

const hu_attributes_gloves_barrette = /** @type {(inputs: {}) => string} */ () => {
	return `Barette`
};

const it_attributes_gloves_barrette = /** @type {(inputs: {}) => string} */ () => {
	return `Sigaretta`
};

const nl_attributes_gloves_barrette = /** @type {(inputs: {}) => string} */ () => {
	return `Baret`
};

const pl_attributes_gloves_barrette = /** @type {(inputs: {}) => string} */ () => {
	return `Berety`
};

const pt_attributes_gloves_barrette = /** @type {(inputs: {}) => string} */ () => {
	return `Barette`
};

const sv_attributes_gloves_barrette = /** @type {(inputs: {}) => string} */ () => {
	return `Baretter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_gloves_barrette = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_gloves_barrette(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_gloves_barrette", locale)
	if (locale === "cs") return cs_attributes_gloves_barrette(inputs)
	if (locale === "da") return da_attributes_gloves_barrette(inputs)
	if (locale === "de") return de_attributes_gloves_barrette(inputs)
	if (locale === "en") return en_attributes_gloves_barrette(inputs)
	if (locale === "es") return es_attributes_gloves_barrette(inputs)
	if (locale === "fr") return fr_attributes_gloves_barrette(inputs)
	if (locale === "hu") return hu_attributes_gloves_barrette(inputs)
	if (locale === "it") return it_attributes_gloves_barrette(inputs)
	if (locale === "nl") return nl_attributes_gloves_barrette(inputs)
	if (locale === "pl") return pl_attributes_gloves_barrette(inputs)
	if (locale === "pt") return pt_attributes_gloves_barrette(inputs)
	return sv_attributes_gloves_barrette(inputs)
};
export { attributes_gloves_barrette as "attributes.gloves_barrette" }